import FeatherIcon from 'feather-icons-react';
import { InputFromUser } from '../Input/input';
import dayjs from 'dayjs';

/**
 * NextConsultationSection Component
 * Simple component for selecting the next consultation date
 */
const NextConsultationSection = ({
    values,
    errors,
    touched,
    setFieldValue,
    IsFilledForm,
}) => {
    // Disable past dates - only allow today and future dates
    const disablePastDates = (current) => {
        return current && current < dayjs().startOf('day');
    };

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        {/* Section Header */}
                        <h4
                            style={{
                                color: '#111827',
                                fontWeight: '700',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px'
                            }}
                        >
                            <FeatherIcon icon="calendar" size="20" style={{ color: '#4f46e5' }} />
                            Next Consultation Date
                        </h4>

                        <InputFromUser
                            disabled={IsFilledForm}
                            placeholder="Enter Date"
                            type="date"
                            name="dateOfMedicalStore"
                            LabelClassName="col-form-label"
                            onBlur={undefined}
                            label="Next Consultation Date"
                            FormGroupClassName="col"
                            error={errors?.dateOfMedicalStore}
                            value={values?.dateOfMedicalStore}
                            onChange={v => {
                                setFieldValue('dateOfMedicalStore', v);
                                setFieldValue('nextConsultationDate', v);
                            }}
                            FormControlClassName="form-control"
                            touched={touched?.dateOfMedicalStore}
                            disabledDate={disablePastDates}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NextConsultationSection;
